<!--
 © Copyright 2026 Daikin Industries, Ltd. All rights reserved.

 This software is the proprietary information of Daikin Industries, Ltd.
 By using this software, you agree to the following terms:

 1. You are granted a revocable non-exclusive, non-transferable license to use this software.
 2. You agree not to modify, distribute, or create derivative works based on this software.
 3. Unauthorized copying, distribution, or use of any portion of this software is strictly prohibited.
 4. This software is protected by copyright laws and international treaties.
 5. Any violation of these terms will result in the termination of your license and may result in legal action.
 6. This is Daikin's proprietary software and may not be used in an unauthorized manner or without express authorization from Daikin.
-->

<div class="dynamic-api-viewer">
  <!-- Header Section -->
  <div class="viewer-header">
    <div class="header-content">
      <div class="header-top">
        <button class="back-btn" (click)="goBack()" [title]="isEmbedded ? 'Go back to API Explorer' : 'Go back to API Explorer'">
          ← {{ isEmbedded ? 'Back to Explorer' : 'Back to Explorer' }}
        </button>
      </div>

      <div *ngIf="operation" class="operation-info">
        <div class="operation-header">
          <h1>{{ formatOperationName(operation.name) }}</h1>
        </div>

        <div class="operation-details">
          <p class="operation-description" *ngIf="operation.description">{{ operation.description }}</p>

          <div class="operation-info-grid">
            <div class="info-item">
              <label>Application:</label>
              <span class="info-value">{{ operation.applicationName }}</span>
            </div>
            <div class="info-item" *ngIf="operation.version">
              <label>Version:</label>
              <span class="info-value">{{ operation.version }}</span>
            </div>
            <div class="info-item">
              <label>Parameters:</label>
              <div class="parameters-tags">
                <ng-container *ngIf="operation.parameters && operation.parameters.length > 0">
                  <span *ngFor="let param of operation.parameters"
                        class="param-tag"
                        [class.required]="param.required"
                        [title]="param.name + ' (' + param.type + ')' + (param.required ? ' - Required' : ' - Optional')">
                    {{ param.name }}
                  </span>
                </ng-container>
                <ng-container *ngIf="operation.parameters == undefined || operation.parameters.length === 0">
                  <span>-</span>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-state">
    <div class="loading-spinner"></div>
    <p>Preparing API test interface...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error" class="error-state">
    <div class="error-icon">⚠️</div>
    <h3>Failed to Load API Interface</h3>
    <p>{{ error }}</p>
    <div class="error-actions">
      <button class="retry-btn" (click)="retrySwaggerUI()">Retry</button>
      <button class="back-btn secondary" (click)="goBack()">Go Back</button>
    </div>
  </div>

  <!-- Swagger UI Container -->
  <div *ngIf="!loading && !error" class="swagger-content">
    <div class="swagger-container swagger-short" #swaggerContainer>
      <!-- Swagger UI will be rendered here -->
    </div>
  </div>
</div>
